import { useFeatureGate } from "@statsig/react-bindings";
import { useMemo } from "react";

import { featureFlag } from "@/context/FeatureFlagProvider/featureFlags";

import { MetricType } from "../types";

export interface MetricOption {
  label: string;
  value: MetricType;
}

export type MetricConfig = "standard" | "sales-only";

export const useMetricOptions = (config: MetricConfig = "standard"): MetricOption[] => {
  const { value: isSalesUnitsEnabled } = useFeatureGate(featureFlag.salesUnitsEnabled);

  const metricOptions = useMemo(() => {
    if (config === "sales-only") {
      const baseOptions: MetricOption[] = [
        { label: "Sales Revenue", value: MetricType.SALES_REVENUE },
      ];

      // Add Sales Units option based on feature flag
      if (isSalesUnitsEnabled) {
        baseOptions.push({ label: "Sales Units", value: MetricType.SALES_UNITS });
      }

      return baseOptions;
    }

    // Standard configuration (Marketing ROI, ROAS, Sales Units)
    const baseOptions: MetricOption[] = [
      { label: "Marketing ROI", value: MetricType.MARKETING_ROI },
      { label: "Return on Ad Spend", value: MetricType.RETURN_ON_AD_SPEND },
    ];

    // Add Sales Units option based on feature flag
    if (isSalesUnitsEnabled) {
      baseOptions.push({ label: "Sales Units", value: MetricType.SALES_UNITS });
    }

    return baseOptions;
  }, [isSalesUnitsEnabled, config]);

  return metricOptions;
};
